export type RouteKey =
  | "dashboard"
  | "moduleLibrary"
  | "moduleLibraryDetail"
  | "profile"
  | "profileOverview"
  | "profileParameters"
  | "profileDelegate"
  | "profileDelegateAdd"
  | "profileDelegateUpdate"
  | "notification"
  | "contentPage"
  | "login"
  | "chooseCustomer"
  | "borrowCustomer"
  | "borrowCustomerToken"
  | "endUserAgreement"
  | "blockedAccount"
  | "newPassword"
  | "resetPassword"
  | "maintenance"
  | "notFound";

export type BreadcrumbConfig = {
  parent?: RouteKey;
  labelKey: string;
  label?: string;
  to?: string;
};

export type RouteConfig = {
  path: string;
  breadcrumb?: BreadcrumbConfig;
};

export const ROUTES: Record<RouteKey, RouteConfig> = {
  dashboard: {
    path: `${BASE_PATH}/`,
  },
  moduleLibrary: {
    path: `${BASE_PATH}/modules/:parentSlug/:moduleSlug`,
    breadcrumb: {
      labelKey: "document_library.breadcrumb",
    },
  },
  moduleLibraryDetail: {
    path: `${BASE_PATH}/modules/:parentSlug/:moduleSlug/document/:documentId`,
  },
  profile: {
    path: `${BASE_PATH}/profile`,
    breadcrumb: {
      labelKey: "navigation.label_user_account",
    },
  },
  profileOverview: {
    path: `${BASE_PATH}/profile`,
    breadcrumb: {
      parent: "profile",
      labelKey: "profile.tabs.profil",
    },
  },
  profileParameters: {
    path: `${BASE_PATH}/profile/parameters`,
    breadcrumb: {
      parent: "profile",
      labelKey: "profile.parameters.title",
    },
  },
  profileDelegate: {
    path: `${BASE_PATH}/profile/delegate/list`,
    breadcrumb: {
      parent: "profile",
      labelKey: "profile.delegate.title",
    },
  },
  profileDelegateAdd: {
    path: `${BASE_PATH}/profile/delegate/create`,
    breadcrumb: {
      parent: "profileDelegate",
      labelKey: "profile.delegate.add_user",
    },
  },
  profileDelegateUpdate: {
    path: `${BASE_PATH}/profile/delegate/edit/:id`,
    breadcrumb: {
      parent: "profileDelegate",
      labelKey: "common.button_update",
    },
  },
  notification: {
    path: `${BASE_PATH}/notification`,
    breadcrumb: {
      labelKey: "notifications.title",
    },
  },
  contentPage: {
    path: `${BASE_PATH}/page/:code`,
  },
  login: {
    path: `${BASE_PATH}/login`,
  },
  chooseCustomer: {
    path: `${BASE_PATH}/choose_customer`,
  },
  borrowCustomer: {
    path: `${BASE_PATH}/borrow_customer`,
  },
  borrowCustomerToken: {
    path: `${BASE_PATH}/borrow_customer/:token`,
  },
  endUserAgreement: {
    path: `${BASE_PATH}/end_user_agreement`,
  },
  blockedAccount: {
    path: `${BASE_PATH}/blocked_account`,
  },
  newPassword: {
    path: `${BASE_PATH}/new_password/:token`,
  },
  resetPassword: {
    path: `${BASE_PATH}/reset_password`,
  },
  maintenance: {
    path: `${BASE_PATH}/maintenance`,
  },
  notFound: {
    path: `${BASE_PATH}/*`,
  },
};
